import { useState } from 'react';

import MaterialIcon from '@/components/atom/MaterialIcon';
import TooltipTailUp from '@/components/atom/icon/qna/TooltipTailUp';
import ClickLogger from '@/components/common/ClickLogger';
import { EWebTreatmentRequestLog } from '@/entities/diagnosis/libs';
import { TreatmentRequest } from '@/models/diagnosis';
import theme from '@/styles/theme';

interface Props {
  treatmentRequest: TreatmentRequest;
  openSearchDoctorSortFilterBottomSheet: () => void;
  handleSearchDoctorSpecialistOnlySelect: (specialistOnly: boolean) => void;
}
const TelemedicineDoctorFilter = ({ treatmentRequest, openSearchDoctorSortFilterBottomSheet }: Props) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  const handleTooltipOpen = () => {
    setIsTooltipOpen(true);
  };

  const handleTooltipClose = () => {
    setIsTooltipOpen(false);
  };

  return (
    <div className='flex items-center justify-between bg-white px-[24px] py-[12px]'>
      <div className='flex items-center gap-[4px]'>
        <span className='typography-ui-17sb text-gray-700'>
          나에게 <span className='text-green-700'>딱 맞는</span> 의사
        </span>
        <div className='relative'>
          <button
            onMouseEnter={handleTooltipOpen}
            onMouseLeave={handleTooltipClose}
            className='flex items-center justify-center'
          >
            <MaterialIcon name='info' size={16} color={theme.color.gray300} />
          </button>
          {isTooltipOpen && (
            <div
              className='absolute top-[24px] left-[-25px] z-10 flex flex-col items-start'
              onMouseEnter={handleTooltipOpen}
              onMouseLeave={handleTooltipClose}
            >
              <div className='relative flex flex-col items-start'>
                <div className='absolute top-[-8px] left-[30px]'>
                  <TooltipTailUp />
                </div>
                <div className='flex w-[180px] items-center gap-[6px] rounded-[8px] bg-gray-700 px-[12px] py-[7px] text-center'>
                  <span className='typography-ui-13m text-center text-white'>
                    내가 선택한 시간, 조건과 <br />
                    일치하는 의사들만 보여드려요.
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <ClickLogger
        params={{
          eventName: EWebTreatmentRequestLog.ClickDoctorSort,
          payload: {
            current_sort: treatmentRequest.getSortKey(),
          },
        }}
      >
        <button onClick={openSearchDoctorSortFilterBottomSheet} className='flex items-center'>
          <span className='typography-ui-13m text-gray-500'>{treatmentRequest.getSortKeyName()}</span>
          <MaterialIcon name='swap_vert' size={16} color={theme.color.gray500} />
        </button>
      </ClickLogger>
    </div>
  );
};

export default TelemedicineDoctorFilter;
